import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 160,
    damping: 26,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden
      data-testid="scroll-progress"
      style={{
        scaleX,
        transformOrigin: "0% 50%",
        background:
          "linear-gradient(90deg, var(--accent-blue), var(--accent-crimson-hover))",
        boxShadow: "0 0 14px var(--accent-blue-glow)",
      }}
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] pointer-events-none"
    />
  );
};

export default ScrollProgress;
